import * as classnames from 'classnames'
import * as React from 'react'

import { Site } from '../../../../common/constants/siteList'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import createAutoSuggestDataContainer from '../../../shared/components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../../shared/components/autosuggest/autoSuggestLogicContainer'
import HostedHeader from '../../../shared/components/hostedHeader'
import SearchResultHeaders from '../../../shared/components/searchResultHeaders'
import AutoSuggest from '../../components/autosuggest/'

import * as searchResultHeadersStyles from '../../components/header/searchResultHeaders.module.css'
import * as hostedStyles from './hostedSearch.module.css'
import * as styles from './searchHeader.module.css'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

interface IProps {
  location: any
  totalHits: number
  didYouMeanByTerms: any[]
  authorSuggestion: any
  searchHeadings: any
  currentSite: Site
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  openModal: (data: any) => any
}

const SearchHeader = ({
  location,
  totalHits,
  didYouMeanByTerms,
  authorSuggestion,
  searchHeadings,
  currentSite,
  openModal,
  locationParams,
  makeSearchLink
}: IProps) => {
  const hostingSetupSelected = locationParams.hosting_setup === '1'

  const seoMeta = {
    heading: searchHeadings.heading,
    subHeading: searchHeadings.sub_heading
  }
  const searchResultHeaderProps = {
    locationParams,
    totalHits,
    seoMeta,
    didYouMeanByTerms,
    authorSuggestion,
    styles: hostingSetupSelected ? hostedStyles : searchResultHeadersStyles,
    TagName: 'h1'
  }

  if (hostingSetupSelected) {
    return (
      <HostedHeader wide openModal={openModal}>
        <AutoSuggestContainer
          inputName="term"
          value={locationParams.term}
          placeholder="Search within these results"
          currentSite={currentSite}
          locationParams={locationParams}
          makeSearchLink={makeSearchLink}
        />
        <SearchResultHeaders {...searchResultHeaderProps} />
      </HostedHeader>
    )
  } else {
    return (
      <div className={styles.searchPageHeader}>
        <AutoSuggestContainer
          inputName="term"
          value={locationParams.term}
          placeholder="Search within these results"
          currentSite={currentSite}
          locationParams={locationParams}
          makeSearchLink={makeSearchLink}
        />
        <SearchResultHeaders {...searchResultHeaderProps} />
      </div>
    )
  }
}

export default SearchHeader
